import { Link } from 'gatsby';
import React from 'react';

import './style.scss';

const Header = () => (
  <header
    className="HeaderBlock"
  >
    <div className="nav-container nav-container-md">
      <div className="nav-container nav-item nav-item-10">
        <h4>
          <Link
            to="/"
            className="LinkText"
          >
            Home
          </Link>
        </h4>
        <h4 className="divider">/</h4>
        <h4>
          <Link
            to="/about"
            className="LinkText"
          >
            About
          </Link>
        </h4>
      </div>
      {/* TODO  */}
      {/* Dark mode Switch */}
      {/* xs2 => max-width: 16.666667%
             flex-basic: 16.666667%
      <Grid item xs={2}>
        <p>AAA</p>
      </Grid> */}
    </div>
  </header>
);

export default Header;
